export default "__VITE_ASSET__BtAWUqBB__"